<template>
   
<div class="categorytabs">
      <div class="container">
         <div class="categorytabs__wrap">
            
            <div class="categorytabs__item" v-for="cat in categories" v-bind:key="cat.id">
               <a @click='navigate(cat)'>
                  <div class="categorytabs__img" v-bind:style="{ background: 'url(' + cat.subThumb + ')' + 'no-repeat center center' }"></div>
                  <!-- <div class="categorytabs__img" v-bind:style="{ background: 'url(' + imgTest + ')' + 'no-repeat center center' }"></div> -->
                  <div class="categorytabs__content">
                     <span>{{ cat.subTitle }}</span>
                  </div>
               </a> 
            </div>

         </div>
      </div>
   </div>

</template>

<script>
   import imgTest from '@/assets/img/images/things-to-do/thumbnails/thumb-reef-cruises.jpg';

   export default {

      name: 'categoryTabs',
      props: ['categories'],

      data(){
         return {
            imgTest
         }
      },

      methods: {
         navigate (cat) {
            this.$router.currentRoute.params.subUrlSegment = cat.subUrlSegment
            this.$router.push({ name: 'subCategory', params: this.$router.currentRoute.params })
         },
      },

   }

</script>